<template>
  <div class="c-details-meta o-container">
    <div class="o-row">
      <div class="o-column o-column-12 o-column-lg-6">
        <details-meta-item
          :items="product.genres"
          :title="$t('product.genre')"
        ></details-meta-item>
        <details-meta-item
          :items="product.actors"
          :title="$t('product.starring')"
          item-class="o-typography--action"
          @click:item="search"
        ></details-meta-item>
      </div>

      <div class="o-column o-column-12 o-column-lg-6">
        <details-meta-item
          :items="product.directors"
          :title="$t('product.director')"
          item-class="o-typography--action"
          @click:item="search"
        ></details-meta-item>
        <details-meta-item
          :items="product.audioLanguages"
          :title="$t('product.audioLanguage')"
        ></details-meta-item>
        <details-meta-item
          :items="product.subtitleLanguages"
          :title="$t('product.subtitles')"
        ></details-meta-item>
        <details-meta-item
          :items="product.countries"
          :title="$t('product.productionCountry')"
        ></details-meta-item>
      </div>
    </div>
  </div>
</template>
<script>
  import { searchMixin } from '@/index/shared/mixins';
  import DetailsMetaItem from './meta-item.vue';

  export default {
    components: {
      DetailsMetaItem,
    },
    mixins: [
      searchMixin,
    ],
    props: {
      product: Object,
    },
  };
</script>
